import Phaser from "phaser";
import { BurgerMenu } from "./BurgerMenu";

export class GUI extends Phaser.GameObjects.Container {
    private readonly burgerMenu: BurgerMenu;

    constructor(scene: Phaser.Scene) {
        super(scene);
        this.setDepth(1000);
        this.burgerMenu = new BurgerMenu(scene);
        this.add(this.burgerMenu);
        this.relayout();
    }

    public relayout(): void {
        const { width, height } = this.scene.scale;
        if (width < height) {
            const scale = Math.min(1, (width - 32) / 868);
            this.burgerMenu.setPosition(16 + 808 * scale, 20 + 60 * scale).setScale(scale);
            return;
        }
        this.burgerMenu.setPosition(width - 60, 60).setScale(1);
    }

    public isMenuOpen(): boolean {
        return this.burgerMenu.isMenuOpen();
    }
}
